/**
 * Limits what characters can be entered in a Formik field using a regex
 * pattern.
 *
 * @param {Event} event - The change event.
 * @param {function} setFieldValue - The form's setFieldValue function.
 * @param {RegExp} pattern - The regex pattern to match.
 */
 
export const formikInputLimit = (event, setFieldValue, regex) => {
  event.preventDefault();
  const { name, value, type } = event.target;
  if (type === 'tel') {
    if (
      isRepeated(value, '(') ||
      isRepeated(value, ')') ||
      isRepeated(value, ' ')
    )
      return;
    if (value.replace(/[^\d]/g, '').length > 13) return;
    if (value.indexOf('+', 1) > 0) return;
    if (value.length > 20) return;
  }
  setFieldValue(name, value.replace(regex, ''));
};

/**
 * Validate the format of a string using a regex pattern.
 * In case the pattern is not defined the function will validate that the string is not empty.
 * @param {string} value
 * @param {RegExp} patternRegex
 * @returns {boolean}
 */
export const isValidFormat = (value, patternRegex) => {
  if (patternRegex) {
    return patternRegex.test(value);
  }

  if (value) {
    return true;
  }

  return false;
};

/**
 * Check if a char is immediately repeated
 *
 * @param {string} str - string to validate
 * @param {string} char - char to find
 * @returns {boolean}
 *
 * Examples
 * 123((423  >> '(' true
 * 123(42(3()  >> '(' false
 * +123++3213  >>  '+' true
 *
 */
function isRepeated(str, char) {
  let indx = -1;

  for (let i = 0; i < str.length; i++) {
    indx = str.indexOf(char, indx + 1);
    if (indx >= 0 && str[indx] === str[indx + 1]) return true;
    else if (indx === -1) return false;
  }
}

export function isObjEqual(obj1, obj2) {
  if (obj1 === obj2) return true;

  if (
    obj1 == null ||
    obj2 == null ||
    typeof obj1 !== 'object' ||
    typeof obj2 !== 'object'
  ) {
    return false;
  }

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) return false;

  for (const key of keys1) {
    if (!keys2.includes(key) || !isObjEqual(obj1[key], obj2[key])) {
      return false;
    }
  }

  return true;
}
